// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"8ae0ca93","317":"ac8a1f74","846":"1552273c"}[chunkId] + ".js";
};